import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from 'chart.js';
import {MatTableDataSource} from '@angular/material/table';
import {Patient} from '../../../../model/user/Patient';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {Router} from '@angular/router';

@Component({
    selector: 'app-bar-chart-stable-unstable-duration-uc',
    templateUrl: './bar-chart-stable-unstable-duration-uc.component.html',
    styleUrls: ['./bar-chart-stable-unstable-duration-uc.component.css']
})

export class BarChartStableUnstableDurationUCComponent implements OnInit, OnDestroy {
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription: Subscription;
  subscription1: Subscription;
  // ******************************************************************************************************************
  // bar chart dei pazienti globali malati in miglioramento, in peggioramento, stabili, per genere
  // ******************************************************************************************************************
  // bar chart arrays
  remissione = [];
  recidiva = [];
  // 10, 20, GSCOS, IMM, 40
  // other arrays
  stabiliRecidiva10 = 0;
  stabiliRemissione10 = 0;
  instabiliMiglRecidiva10 = 0;
  instabiliPegRecidiva10 = 0;
  instabiliMiglRemissione10 = 0;
  instabiliPegRemissione10 = 0;
  
  stabiliRecidiva20 = 0;
  stabiliRemissione20 = 0;
  instabiliMiglRecidiva20 = 0;
  instabiliPegRecidiva20 = 0;
  instabiliMiglRemissione20 = 0;
  instabiliPegRemissione20 = 0;
  
  stabiliRecidiva30 = 0;
  stabiliRemissione30 = 0;
  instabiliMiglRecidiva30 = 0;
  instabiliPegRecidiva30 = 0;
  instabiliMiglRemissione30 = 0;
  instabiliPegRemissione30 = 0;

  stabiliRecidiva40 = 0;
  stabiliRemissione40 = 0;
  instabiliMiglRecidiva40 = 0;
  instabiliPegRecidiva40 = 0;
  instabiliMiglRemissione40 = 0;
  instabiliPegRemissione40 = 0;

  // elements for chart
  canvas: any;
  ctx: any;
  myChartStableUnstableUCDuration: Chart;
  // ******************************************************************************************************************
  // bar chart
  // ******************************************************************************************************************
  public barChartLabelsGlobal = ['0-10 ANNI-STABILI','0-10 ANNI-IN MIGLIORAMENTO','0-10 ANNI-IN PEGGIORAMENTO',
  '10-20 ANNI-STABILI','10-20 ANNI-IN MIGLIORAMENTO','10-20 ANNI-IN PEGGIORAMENTO',
  '20-30 ANNI-STABILI','20-30 ANNI-IN MIGLIORAMENTO','20-30 ANNI-IN PEGGIORAMENTO',
  '30+ ANNI-STABILI','30+ ANNI-IN MIGLIORAMENTO','30+ ANNI-IN PEGGIORAMENTO'];
  public barChartTypeGlobal = 'horizontalBar';
  public barChartLegendGlobal = true;
  public barChartDataGlobal = [
    {
      data: this.recidiva,
      barThickness: 10,
      backgroundColor: ['#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', 
      '#ff5232','#ff5232', '#ff5232', '#ff5232','#ff5232', '#ff5232', '#ff5232'],
      hoverBackgroundColor: ['#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507',
      '#d11507','#d11507', '#d11507', '#d11507','#d11507', '#d11507', '#d11507'],
      label: 'RECIDIVA',
      datalabels: {
        color: 'white', // Color for percentage value
      }
    },
    {
      data: this.remissione,
      barThickness: 10,  // number (pixels) or 'flex'
      backgroundColor: ['#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e',
      '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e','#a1e19e', '#a1e19e', '#a1e19e'],
      hoverBackgroundColor: ['#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c',
      '#03c03c','#03c03c', '#03c03c', '#03c03c','#03c03c', '#03c03c', '#03c03c'],
      label: 'REMISSIONE',
      datalabels: {
        color: 'white' // Color for percentage value}
      }
    }
    ];
  // table
  dataSource = new MatTableDataSource();
  headElements = ['name', 'surname', 'card', 'questionnaire', 'email', 'chat'];
  totalSize = 0;
  // TABELLE DISPONIBILI
  isHovered = false;
  // paginator della tabella
  public pageSize = 5;
  public currentPage = 0;
  public tasks: any[];
  @ViewChild(MatPaginator, {static: false}) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
      paginator._intl.previousPageLabel = 'Pagina precedente';
      paginator._intl.nextPageLabel = 'Pagina successiva';
    }
  }

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService,
              private router: Router) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
  }
  ngOnInit(): void {
    this.subscription1 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrieveDurationStableAndUnstable();
    });
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  retrieveDurationStableAndUnstable(){
    this.subscription = this.doctorService.getUCStableAndUnstableDuration().subscribe( data => {
      let keys = Object.keys(data);
      console.log("Data therapy: " + data);
      let values = Object.values(data);
      for (let i in keys){
        var key = keys[i];
        //console.log("Key..." + key);
        if (key === 'StabiliRemissione10'){
          this.stabiliRemissione10 = values[i];
        }
        else if (key === 'StabiliRecidiva10'){
          this.stabiliRecidiva10 = values[i];
        }
        else if (key === 'InstabiliMiglRecidiva10'){
          this.instabiliMiglRecidiva10 = values[i];
        }
        else if (key === 'InstabiliPegRecidiva10'){
          this.instabiliPegRecidiva10 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione10'){
          this.instabiliMiglRemissione10 = values[i];
        }
        else if (key === 'InstabiliPegRemissione10'){
          this.instabiliPegRemissione10 = values[i];
        }
        else if (key === 'StabiliRemissione20'){
          this.stabiliRemissione20 = values[i];
        }
        else if (key === 'StabiliRecidiva20'){
          this.stabiliRecidiva20 = values[i];
        }
        else if (key === 'InstabiliMiglRecidiva20'){
          this.instabiliMiglRecidiva20 = values[i];
        }
        else if (key === 'InstabiliPegRecidiva20'){
          this.instabiliPegRecidiva20 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione20'){
          this.instabiliMiglRemissione20 = values[i];
        }
        else if (key === 'InstabiliPegRemissione20'){
          this.instabiliPegRemissione20 = values[i];
        }
        else if (key === 'StabiliRemissione30'){
          this.stabiliRemissione30 = values[i];
        }
        else if (key === 'StabiliRecidiva30'){
          this.stabiliRecidiva30 = values[i];
        }
        else if (key === 'InstabiliMiglRecidiva30'){
          this.instabiliMiglRecidiva30 = values[i];
        }
        else if (key === 'InstabiliPegRecidiva30'){
          this.instabiliPegRecidiva30 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione30'){
          this.instabiliMiglRemissione30 = values[i];
        }
        else if (key === 'InstabiliPegRemissione30'){
          this.instabiliPegRemissione30 = values[i];
        }
        else if (key === 'StabiliRemissione40'){
          this.stabiliRemissione40 = values[i];
        }
        else if (key === 'StabiliRecidiva40'){
          this.stabiliRecidiva40 = values[i];
        }
        else if (key === 'InstabiliMiglRecidiva40'){
          this.instabiliMiglRecidiva40 = values[i];
        }
        else if (key === 'InstabiliPegRecidiva40'){
          this.instabiliPegRecidiva40 = values[i];
        }
        else if (key === 'InstabiliMiglRemissione40'){
          this.instabiliMiglRemissione40 = values[i];
        }
        else if (key === 'InstabiliPegRemissione40'){
          this.instabiliPegRemissione40 = values[i];
        }
      }
      
      // riempio il vettore della categoria 'recidiva' in ordine stabili, miglioramento e peggioramento
      this.recidiva.push(this.stabiliRecidiva10);
      this.recidiva.push(this.instabiliMiglRecidiva10);
      this.recidiva.push(this.instabiliPegRecidiva10);
      this.recidiva.push(this.stabiliRecidiva20);
      this.recidiva.push(this.instabiliMiglRecidiva20);
      this.recidiva.push(this.instabiliPegRecidiva20);
      this.recidiva.push(this.stabiliRecidiva30);
      this.recidiva.push(this.instabiliMiglRecidiva30);
      this.recidiva.push(this.instabiliPegRecidiva30);
      this.recidiva.push(this.stabiliRecidiva40);
      this.recidiva.push(this.instabiliMiglRecidiva40);
      this.recidiva.push(this.instabiliPegRecidiva40);
      console.log("Recidiva: " + this.recidiva);
      // riempio il vettore della categoria 'remissione' in ordine, stabili, miglioramento e peggioramento
      this.remissione.push(this.stabiliRemissione10);
      this.remissione.push(this.instabiliMiglRemissione10);
      this.remissione.push(this.instabiliPegRemissione10);
      this.remissione.push(this.stabiliRemissione20);
      this.remissione.push(this.instabiliMiglRemissione20);
      this.remissione.push(this.instabiliPegRemissione20);
      this.remissione.push(this.stabiliRemissione30);
      this.remissione.push(this.instabiliMiglRemissione30);
      this.remissione.push(this.instabiliPegRemissione30);
      this.remissione.push(this.stabiliRemissione40);
      this.remissione.push(this.instabiliMiglRemissione40);
      this.remissione.push(this.instabiliPegRemissione40);
      console.log("Remissione: " + this.remissione);
      this.canvasSetting();
    }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  canvasSetting() {
    this.canvas = document.getElementById('myChartStableUnstableUCDuration') as HTMLCanvasElement;
    this.ctx = this.canvas.getContext('2d');
    this.myChartStableUnstableUCDuration = new Chart(this.ctx, {
      type: this.barChartTypeGlobal,
      data: {
        labels: this.barChartLabelsGlobal,
        datasets: this.barChartDataGlobal,
      },
      options: {
        maintainAspectRatio: true,
        responsive: true,
        onHover: (event) => {
          if (this.myChartStableUnstableUCDuration.getElementAtEvent(event).length > 0) {
            if (this.myChartStableUnstableUCDuration.getElementAtEvent(event)[0]['_model'].datasetLabel === 'RECIDIVA' ||
              this.myChartStableUnstableUCDuration.getElementAtEvent(event)[0]['_model'].datasetLabel === 'REMISSIONE') {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          }
        },
        scales: {
          xAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
          yAxes: [{
            display: true,
            stacked: true,
            ticks: {
              fontSize: 12,
              fontStyle: 'bold',
              fontFamily: 'Helvetica',
              fontColor: '#006192'
            }
          }],
        },
        legend: {
          onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
            if (legendItem.text.length > 0 && (legendItem.text === 'RECIDIVA' || legendItem.text === 'REMISSIONE')) {
              this.setHoverVariable();
            } else {
              this.unsetHoverVariable();
            }
          },
          display: true,
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: true,
            fontColor: '#006192',
            fontSize: 18,
            fontFamily: 'Helvetica',
          }
        },
        tooltips: {
          // content: '{pathology}: {number}',
          backgroundColor: '#1c1c1c',
          bodyFontSize: 18,
          titleFontSize: 18,
          cornerRadius: 5,
          caretPadding: 10
        },
        title: {
          display: true,
          text: 'Numero di pazienti',
          fontColor: '#006192',
          fontSize: 20,
          fontFamily: 'Helvetica',
        },
        hover: {
          mode: 'nearest',
          intersect: true
        }
      }
    });
    }

    // pagination della tabella di stabili recidiva patients
  // paginazione effettuata manualmente
  getPagination(data) {
    console.log(data);
    this.dataSource = new MatTableDataSource<Patient>();
    // this.dataSource.data = data;
    this.tasks = data;
    this.currentPage = 0; // così che appena si seleziona il grafico appaia la giusta pagina con le prime persone
    this.totalSize = this.tasks.length;
    this.iterator(); // iterator sistema i nomi alla pagina corretta
  }
  handlePage(event?: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.iterator();
  }
  private iterator() {
    const end = (this.currentPage + 1) * this.pageSize;
    const start = this.currentPage * this.pageSize;
    this.dataSource.data = this.tasks.slice(start, end);
  }
  // set hovered variable
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/general-status');
  }
  openQuestionnaire(patient) {
    this.router.navigateByUrl('/patient-questionnaires-show/' + patient.ssn + '/patient-sccai' + '/general-status');
  }
  openChat(patient) {
    this.router.navigateByUrl('/doctor-chat/' + patient.ssn + '/general-status');
  }
  async delay(ms: number) {
    await new Promise(resolve => setTimeout(() => resolve(), ms)).then(() => console.log('fired'));
  }

}